<template>
    <span class="data-value copy-element">
        <CompassLink :label="email" link="javascript:;" @click="emailClicked">
            <slot />
        </CompassLink>
        <Clipboard :data="email" />
    </span>
</template>

<script>
import EmailMixins from 'mixins/EmailMixins';
import Feature from 'Services/Feature';
import Clipboard from 'vcomponents/utilities/Clipboard.vue';

export default {
    components: {
        Clipboard,
    },
    mixins: [EmailMixins],
    props: {
        email: {
            type: String,
            default: '',
        },
        linkedtype: {
            type: String,
            required: true,
        },
        linkedid: {
            type: Number,
            required: true,
        },
    },
    methods: {
        emailClicked() {
            if (!this.disabled) {
                const prefill =
                    Feature.isEnabled('email-engine') && !this.email ? { checkPrefill: true } : {};
                this.checkEmailProvider({}, prefill, this.email);
            }
        },
    },
};
</script>
